import React,{useState} from 'react'
import '../Amenu.css';
import {ASidebardata} from './ASideBarData'
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import PersonIcon from '@material-ui/icons/Person';
import * as CgProfile from 'react-icons/cg';
import {Link} from 'react-router-dom';
import { IconContext } from 'react-icons';

function ASideBar() {
    const[sidebar,setSidebar]=useState(false);
    const showSidebar=()=>setSidebar(!sidebar);
    return (
        <>
        <IconContext.Provider value={{color:'#fff'}}>
           <div className="navbars">
              <Link to="#" className='menu-bars' >
                <FaIcons.FaBars color="green" onClick={showSidebar}/>
              </Link>
              <div id="logos">
          <img  id="imagemg"src={require('./images/ENH.png')}  />
       
              </div>
        
            <ul id='perfil'><li key='sdsd' onClick={()=>window.location.pathname='admin/home/profile'}>
                <div> <PersonIcon/></div>
                </li></ul>
          </div> 
           
           <div className={sidebar? 'nav-menu active':'nav-menu'}>
           <div className="NavBar">

          <ul className="SidebarList" onClick={showSidebar}>
            <li>
              <Link to="#" className='menu-bars'>
                  <AiIcons.AiOutlineClose color="green"/>
              </Link>
            </li>
              
          {ASidebardata.map((val,key)=>
          {
          return <li key={key} className="row" onClick={()=>window.location.pathname=val.link}>

              <div id="icon">{val.icon}</div> <div div id="title">  {val.title}</div>
              </li>;
          }
          )}
          <div id="mapi">
          <small>© MAPI'S All RIGHTS RESERVED</small>
              </div>

          </ul>
          
          </div>

                    </div>
                    </IconContext.Provider>
        </>
        
     
    )
}

export default ASideBar